import 'styles/Gallery.less'
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Router, Route, Link } from 'react-router'
import assets from 'modules/assets'
import photo from '../../../datas/photos/index.json'
import Image from 'components/Gallery/Image'
import * as actions from 'actions'

class Overview extends Component {
  constructor(props) {
    super(props)
    this.OVERVIEW_ALBUM_NAME = {
      '2016': 'camp-2016-overview',
      '2017': 'camp-2017-overview',
      '2018': 'camp-2018-overview',
      '2019': 'camp-2019-overview',
    }
    this.ALBUM = {
      '2016': {
        'bali': 'camp-2016-bali-overview',
        'chiba': 'camp-2016-chiba-overview',
        'danube': 'camp-2016-danube-overview'
      },
      '2017': {
        'bali': 'camp-2017-bali-overview',
        'chiba': 'camp-2017-chiba-overview',
        'danube': 'camp-2017-romania-overview',
        'france': 'camp-2017-france-overview'
      },
      '2018': {
        'japan1': 'camp-2018-japan1-overview',
        'usa1': 'camp-2018-usa1-overview',
        'japan2': 'camp-2018-japan2-overview',
        'usa2': 'camp-2018-usa2-overview'
      },
      '2019': {
        'japan': 'camp-2019-japan-overview',
      }      
    }
    this.CAMP_NAMES = {
      'bali': 'Bali',
      'chiba': 'Japan',
      'danube': 'Romania',
      'france': 'France',
      'japan1': 'Japan 1',
      'japan2': 'Japan 2',
      'usa1': 'USA 1',
      'usa2': 'USA 2',
      'japan': 'Japan'
    }

    this.IMAGE_SCALE_FACTOR = 0.37
    this.resetLayoutOnMouseOut = false
    this.state = {
      year: this.props.year,
      camps: this.props.camps
    }
  }
  getRandom(x, y) {
    return (Math.floor(Math.random() * (y - x)) + x)
  }
  getBoundingRectangle(photo) {
    const PHOTO_MIN_MARGIN = 10
    return {
      x1: photo.left - PHOTO_MIN_MARGIN,
      y1: photo.top - PHOTO_MIN_MARGIN,
      x2: photo.left + photo.actualSize.width + PHOTO_MIN_MARGIN,
      y2: photo.top + photo.actualSize.height + PHOTO_MIN_MARGIN
    }
  }
  photosOverlap(photo1, photo2) {
    let rect1 = this.getBoundingRectangle(photo1)
    let rect2 = this.getBoundingRectangle(photo2)
    if (rect1.x1 < rect2.x2 && rect1.x2 > rect2.x1 && rect1.y1 < rect2.y2 && rect1.y2 > rect2.y1) {
      return true
    }
    return false
  }
  shuffleArray(arr) {
    for (let i = 1; i < arr.length; i++) {
      let j = this.getRandom(0, i - 1)
      let aux = arr[i]
      arr[i] = arr[j]
      arr[j] = aux
    }
  }
  recreateGrid() {
    let selectedPhotos = this.chooseRandomPhotos(photo[this.OVERVIEW_ALBUM_NAME[this.state.year]].image.slice(0, 24))
    this.setState({
      selectedPhotos: selectedPhotos
    })
  }
  onMouseOverMenu(item) {
    this.resetLayoutOnMouseOut = true
    let selectedPhotos = this.chooseRandomPhotos(photo[this.ALBUM[this.state.year][item]].image.slice(0, 24))
    this.setState({selectedPhotos: selectedPhotos})
    /*
    this.setState({selectedPhotos: []}, () => {
      this.setState({selectedPhotos: selectedPhotos})
    })
    */
  }
  onMouseOutMenu() {
    if (!this.resetLayoutOnMouseOut)
      return
    this.resetLayoutOnMouseOut = false
    this.recreateGrid()
  }
  chooseRandomPhotos(photoList) {
    this.shuffleArray(photoList)
    photoList.map((obj) => {
      obj.actualSize = {
        width: 400 * this.IMAGE_SCALE_FACTOR,
        height: 400 / obj.thumbSize.width * obj.thumbSize.height * this.IMAGE_SCALE_FACTOR
      }
      obj.display = false
    })

    let windowHeight = window.innerHeight
    let windowWidth = window.innerWidth

    var noRows = 4
    var noCols = 6
    if (windowWidth < windowHeight * 1.5) {
      noRows = 4
      noCols = 3
    }
    var cellWidth = windowWidth / noCols
    var cellHeight = windowHeight / noRows

    for (var i = 0; i < Math.min(noCols * noRows, photoList.length); i++) {
      var isOverlap = true
      var trials = 0

      while (isOverlap && trials < 20) {
        isOverlap = false
        let row = Math.floor(i / noCols)
        let col = (i % noCols)
        photoList[i].top = Math.min(cellHeight * row + this.getRandom(-cellHeight / 3 + cellHeight * (3 * trials / 100), cellHeight / 3) + cellHeight / 3, windowHeight - photoList[i].actualSize.height)
        photoList[i].left = cellWidth * col + this.getRandom(-cellWidth / 3 + cellWidth * (3 * trials / 100), cellWidth / 3) + cellWidth / 5

        for (var j = 0; j < i; j++) {
          if (photoList[j].display && this.photosOverlap(photoList[i], photoList[j])) {
            isOverlap = true
            break
          }
        }
        trials++
      }

      if (!isOverlap) {
        photoList[i].display = true
      }
    }

    return photoList
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState == this.state) {
      return false
    }

    return true
  }
  toggleInfo = () => {
    this.props.dispatch(actions.token.infoCamp2016(!this.props.infoCamp2016))
  }
  resizeHandler() {
    this.recreateGrid()
  }
  componentWillReceiveProps(newProps) {
    if (newProps.year == this.props.year) return
    this.setState({
      year: newProps.year,
      camps: newProps.camps
    })
    let selectedPhotos = this.chooseRandomPhotos(photo[this.OVERVIEW_ALBUM_NAME[this.state.year]].image.slice(0, 24))
    this.setState({
      selectedPhotos: selectedPhotos,
      camp2016Info: false
    })
  }
  componentWillMount() {
    let selectedPhotos = this.chooseRandomPhotos(photo[this.OVERVIEW_ALBUM_NAME[this.state.year]].image.slice(0, 24))
    this.setState({
      selectedPhotos: selectedPhotos,
      camp2016Info: false
    })
  }
  componentDidMount() {
    this.props.dispatch(actions.token.toggleHeader(true))
    window.addEventListener('resize', this.resizeHandler.bind(this), false)
  }
  componentWillUnmount() {
    this.props.dispatch(actions.token.toggleHeader(false))
    window.removeEventListener('resize', this.resizeHandler, false)
  }
  infoHover() {
    this.refs.infoIcon.src = assets('icons/info_red.svg')
  }

  infoEndHover() {
    this.refs.infoIcon.src = assets('icons/info_black.svg')
  }

  render() {
  	return (
  		<div className="camp-2016-overview">
        <section className="main-grid">
          <ul className="grid group">
            <div>
              <div className="gallery-overview-text">
                Gakko{this.state.year}
              </div>
              <div className="gallery-overview-menu" onMouseLeave={this.onMouseOutMenu.bind(this)}>
                {
                  this.state.camps[this.state.year].map(camp => {
                    return (<span key={camp} className="overview-menu-link" onMouseEnter={this.onMouseOverMenu.bind(this, camp)} >
                      <Link to={`/gallery/${this.state.year}/${camp}`}>{this.CAMP_NAMES[camp]}<br/></Link>
                    </span>)
                  })
                }
              </div>
              <img className="gallery-overview-info-icon" ref='infoIcon' src={assets('icons/info_black.svg')} onClick={this.toggleInfo} onMouseEnter={this.infoHover.bind(this)} onMouseLeave={this.infoEndHover.bind(this)}/>
            </div>
          </ul>
        </section>
        {this.state.selectedPhotos.map((photo, i) => {
          let imageStyle = {
            top: photo.top,
            left: photo.left,
            width: photo.actualSize.width,
            height: photo.actualSize.height,
            display: photo.display ? '' : 'none'
          }
          return (
            <Image photo={photo} highRes={false} key={photo.id} myId={photo.id} typeOfLoading={Image.loadType.SIMPLE} style={imageStyle}/>
          )
        })}
  		</div>
  	)
	}
}

Overview.contextTypes = {
}
Overview.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    location:ownProps.location,
    infoCamp2016: state.token.infoCamp2016
  }
}

export default connect(mapStateToProps)(Overview)



// WEBPACK FOOTER //
// ./src/components/Gallery/GalleryOverview.js